export const stockData = (state, rootState) => {
  return state.stockData;
}

export const pricingTables = (state, rootState) => {
  return state.pricingTables;
}

export const savedStock = (state, rootState) => {
  return state.savedStock;
}

export const stockLoaded = (state, rootState) => {
  return state.stockLoaded;
}
